export interface ICheckUser {
  isLoginEqual: boolean;
  isEmailEqual: boolean;
}
